import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { _ as r } from "../chunks/tslib.es6.js";
import { property as e } from "../core/accessorSupport/decorators/property.js";
import "../core/arrayUtils.js";
import "../core/has.js";
import "../core/accessorSupport/ensureType.js";
import { subclass as o } from "../core/accessorSupport/decorators/subclass.js";
import { owningCollectionProperty as s } from "../core/support/OwningCollection.js";
import t from "./Layer.js";
import { BlendLayer as i } from "./mixins/BlendLayer.js";
import { ScaleRangeLayer as p } from "./mixins/ScaleRangeLayer.js";
import { GraphicsCollection as a } from "../support/GraphicsCollection.js";
import c from "../symbols/support/ElevationInfo.js";

var n = /*#__PURE__*/function (_i) {
  _inherits(n, _i);

  var _super = _createSuper(n);

  function n(r) {
    var _this;

    _classCallCheck(this, n);

    _this = _super.call(this, r), _this.elevationInfo = null, _this.graphics = new a(), _this.screenSizePerspectiveEnabled = !0, _this.type = "graphics", _this.internal = !1;
    return _this;
  }

  _createClass(n, [{
    key: "destroy",
    value: function destroy() {
      this.removeAll(), this.graphics.destroy();
    }
  }, {
    key: "add",
    value: function add(r) {
      return this.graphics.add(r), this;
    }
  }, {
    key: "addMany",
    value: function addMany(r) {
      return this.graphics.addMany(r), this;
    }
  }, {
    key: "removeAll",
    value: function removeAll() {
      return this.graphics.removeAll(), this;
    }
  }, {
    key: "remove",
    value: function remove(r) {
      this.graphics.remove(r);
    }
  }, {
    key: "removeMany",
    value: function removeMany(r) {
      this.graphics.removeMany(r);
    }
  }, {
    key: "on",
    value: function on(r, e) {
      return _get(_getPrototypeOf(n.prototype), "on", this).call(this, r, e);
    }
  }, {
    key: "graphicChanged",
    value: function graphicChanged(r) {
      this.emit("graphic-update", r);
    }
  }]);

  return n;
}(i(p(t)));

r([e({
  type: c
})], n.prototype, "elevationInfo", void 0), r([e(s(a, "graphics"))], n.prototype, "graphics", void 0), r([e({
  type: ["show", "hide"]
})], n.prototype, "listMode", void 0), r([e()], n.prototype, "screenSizePerspectiveEnabled", void 0), r([e({
  readOnly: !0
})], n.prototype, "type", void 0), r([e({
  constructOnly: !0
})], n.prototype, "internal", void 0), n = r([o("esri.layers.GraphicsLayer")], n);
var h = n;
export { h as default };